import * as M from '@mantine/core';
import { IconDotsVertical } from '@tabler/icons-react';

import { handleChangeLocaleTime } from '../../../../../shared/utils/time';

import type { IProdoqCompanyResponse } from '../../../../../shared/types/prodoq';

const tableHead = ['회사코드', '회사명', '대표자명', '대표 이메일', '보유 역할 목록', '등록일시', '관리'];

export const getPercentage = (value: number, total: number): number => {
  if (total === 0) return 0;

  return Math.round((value / total) * 1000) / 10;
};

const MAX_VISIBLE_ROLE_COUNT = 4;

interface IProdoqMemberTableProps {
  data: IProdoqCompanyResponse[];
  openCompanyInfoModal: (company: IProdoqCompanyResponse) => void;
  openRoleRegModal: (company: IProdoqCompanyResponse) => void;
  openPermissionModal: (company: IProdoqCompanyResponse) => void;
}

export default function ProdoqMemberTable(props: IProdoqMemberTableProps) {
  const { data, openCompanyInfoModal, openRoleRegModal, openPermissionModal } = props;

  return (
    <M.Table.ScrollContainer minWidth={1200}>
      <M.Table>
        <M.Table.Thead>
          <M.Table.Tr>
            {tableHead.map((head) => (
              <M.Table.Th key={head}>{head}</M.Table.Th>
            ))}
          </M.Table.Tr>
        </M.Table.Thead>
        <M.Table.Tbody>
          {data.map((item) => (
            <M.Table.Tr key={item.companyId}>
              <M.Table.Td>{item.companyId}</M.Table.Td>
              <M.Table.Td maw={200} ta="left">
                <M.Text truncate size="sm">
                  {item.name}
                </M.Text>
              </M.Table.Td>
              <M.Table.Td ta="left">{item.repName}</M.Table.Td>
              <M.Table.Td ta="left" maw={200}>
                <M.Text truncate size="sm">
                  {item.email}
                </M.Text>
              </M.Table.Td>
              <M.Table.Td maw={280}>
                <M.List size="sm" listStyleType="none">
                  {item.roles.slice(0, MAX_VISIBLE_ROLE_COUNT).map((role) => (
                    <M.List.Item key={role.id} ta="left">
                      <M.Text maw={280} truncate size="sm">
                        {`${role.roleName} (${role.roleNameEn})`}
                      </M.Text>
                    </M.List.Item>
                  ))}
                  {item.roles.length > MAX_VISIBLE_ROLE_COUNT && (
                    <M.List.Item ta="left">
                      <M.Text maw={280} truncate size="sm">
                        {`외 ${item.roles.length - MAX_VISIBLE_ROLE_COUNT}개`}
                      </M.Text>
                    </M.List.Item>
                  )}
                </M.List>
              </M.Table.Td>
              <M.Table.Td>{handleChangeLocaleTime(item.regDt)}</M.Table.Td>
              <M.Table.Td>
                <M.Menu withArrow position="bottom-end">
                  <M.Menu.Target>
                    <M.ActionIcon variant="default">
                      <IconDotsVertical size={16} />
                    </M.ActionIcon>
                  </M.Menu.Target>
                  <M.Menu.Dropdown>
                    <M.Menu.Item onClick={() => openPermissionModal(item)}>권한 수정</M.Menu.Item>
                    <M.Menu.Item onClick={() => openRoleRegModal(item)}>역할 관리</M.Menu.Item>
                  </M.Menu.Dropdown>
                </M.Menu>
              </M.Table.Td>
            </M.Table.Tr>
          ))}
        </M.Table.Tbody>
      </M.Table>
    </M.Table.ScrollContainer>
  );
}
